<template>
<div class="wrapper">
    <parallax class="page-header header-filter" parallax-active="true" :style="headerStyle">
        <div class="container">
            <div class="md-layout">
                <div class="md-layout-item md-size-66 md-small-size-100 mx-auto text-center">
                    <h1 class="title">
                        dorfladen.app
                    </h1>
                    <h4>
                        Die Plattform für Dorf- und Bürgerläden.
                    </h4>
                    <br />
                    <div class="md-layout-item md-size-50 mx-auto md-xsmall-size-100">
                        <!--drop-down direction="down">
                            <md-button slot="title" class="md-button md-success md-round md-block dropdown-toggle" data-toggle="dropdown">
                                Dorfladen auswählen
                            </md-button>
                            <ul class="dropdown-menu dropdown-menu-right" v-for="dorfladen in userList" :key="dorfladen.id">
                                <li>
                                    <router-link :to="'/dorfladen/' + dorfladen.id">{{
                      dorfladen.name
                    }}</router-link>
                                </li>
                                <li>test</li>
                                <li>test</li>
                            </ul>
                        </drop-down-->
                        <drop-down direction="down" multi-level>
                            <md-button slot="title" class="md-button md-success md-round md-block dropdown-toggle" data-toggle="dropdown">
                                Dorfladen auswählen
                            </md-button>
                            <ul class="dropdown-menu  dropdown-menu-right">
                                <li v-for="dorfladen in userList" :key="dorfladen.id">
                                    <router-link :to="'/dorfladen/' + dorfladen.id">{{
                      dorfladen.name
                    }}</router-link>
                                </li>
                            </ul>
                        </drop-down>
                    </div>
                </div>
            </div>
        </div>
    </parallax>
    <div class="main main-raised">
        <br />
        <h2 class="title text-center">
            Dorfläden
        </h2>
        <br />
        <div class="md-layout md-alignment-top-center" v-for="dorfladen in userList" :key="dorfladen.id">
            <div class="md-layout-item md-gutter md-large-size-20 md-medium-size-60 md-small-size-50 md-xsmall-size-100" style="padding: 30px; max-width: 600px;">
              <router-link :to="'/dorfladen/' + dorfladen.id">
                <blog-card :shadow-normal="false" :no-colored-shadow="false" :card-image="dorfladen.profileImageHref">
                    <template slot="cardContent">
                        <h6 class="card-category text-primary">
                            {{ dorfladen.zip }} {{ dorfladen.location }}
                        </h6>
                        <h4 class="card-title">
                            <a :to="'/dorfladen/' + dorfladen.id">{{ dorfladen.name }}</a>
                        </h4>
                        <p class="card-description">
                            {{ dorfladen.descriptionShort }}
                            <router-link :to="'/dorfladen/' + dorfladen.id" color="#56ad45">Zum Dorfladen {{ dorfladen.name }}</router-link>
                        </p>
                    </template>
                </blog-card>
                </router-link>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    BlogCard
} from "@/components";
import Mixins from "@/plugins/basicMixins";
import axios from "axios";
import {
    mapGetters
} from "vuex";

export default {
    components: {
        BlogCard
    },
    mixins: [Mixins.HeaderImage],
    bodyClass: "blog-post",
    data: () => ({
        aboutme2: null,
        userList: [],
        image: require("@/assets/img/dorfladen/landscape-666927_1280.jpg")
    }),
    mounted() {
        this.$store.dispatch("getUserList").then(result => {
            this.userList = result;
        });
    },
    methods: {}
};
</script>

<style lang="scss"></style>
